import API from '../utils/api';
import { TERMINAL_SERVICE_ENDPOINT_URL } from '../constants/defaultValues';

const getCoupon = async ({ couponNumber }) => {
    try {
        const res = await API.get(`${TERMINAL_SERVICE_ENDPOINT_URL}/book-bet/${couponNumber}`);

        return res.data;
    } catch (error) {
        console.error(error);
        return { info: { success: false } };
    }
};

const BookBetService = {
    getCoupon,
};

export default BookBetService;
